import styled from 'styled-components';

export const Container = styled.div`
  width: 100%;
  margin-top: 25px;
  display: flex;
  flex-wrap: wrap;
  row-gap: 6px;
`;

export const TableLegendItem = styled.div`
  display: flex;
  align-items: center;
  font-size: 12px;
  margin-right: 15px;

  div {
    background: ${({ color }) => color};
    width: 16px;
    height: 16px;
    border-radius: 50%;
    margin-right: 8px;
    content: '';
  }
`;

export const TableLegendMarker = styled.div`
  display: flex;
  align-items: center;
  font-size: 12px;
  margin-right: 15px;

  span {
    font-size: 16px;
    line-height: 1;
    margin-right: 8px;
  }
`;
